import { render, staticRenderFns } from "./NoticeDeatil.vue?vue&type=template&id=5ac6e5e9&"
import script from "./NoticeDeatil.vue?vue&type=script&lang=js&"
export * from "./NoticeDeatil.vue?vue&type=script&lang=js&"
import style0 from "./NoticeDeatil.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports